<template>
  <main class="placeholder">
    <h1 class="placeholder__title">{{ title }}</h1>
    <p class="placeholder__text">Contenu à définir.</p>
  </main>
</template>

<script>
export default {
  name: "FooterPlaceholderView",
  computed: {
    title() {
      return this.$route.meta.title || "Page";
    },
  },
};
</script>

<style lang="scss" scoped>
.placeholder {
  padding: 2rem 1rem;
  max-width: 40rem;
  margin: 0 auto;
}

.placeholder__title {
  font-size: 1.5rem;
  margin: 0 0 0.5rem;
}

.placeholder__text {
  margin: 0;
  color: #555;
}
</style>
